import React, { useEffect, useState } from "react";
import axios from "axios";
import styles from "../../Alumni/AlumniPages.module.css";

const API = process.env.REACT_APP_BACKEND_API_URL;

const AlumniReports = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`${API}/api/alumni-admin/reports/cohort-wise`)
      .then(({ data }) => setData(data))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className={styles.emptyState}>Loading reports...</div>;

  const { summary, cohorts } = data;

  return (
    <div>
      <h1 className={styles.heading}>Alumni Reports</h1>
      <p className={styles.subheading}>Cohort-wise registration and profile-completion counts.</p>

      <div className={styles.grid}>
        <div className={styles.statCard}>
          <div className={styles.statValue}>{summary.total_registered}</div>
          <div className={styles.statLabel}>Total Registered Alumni</div>
        </div>
        <div className={styles.statCard}>
          <div className={styles.statValue}>{summary.profile_completed}</div>
          <div className={styles.statLabel}>Profiles Completed</div>
        </div>
        <div className={styles.statCard}>
          <div className={styles.statValue}>{summary.pending_requests}</div>
          <div className={styles.statLabel}>Pending Approvals</div>
        </div>
      </div>

      <table className={styles.table}>
        <thead>
          <tr>
            <th>Cohort</th>
            <th>Batch</th>
            <th>Registered</th>
            <th>Profile Completed</th>
            <th>Employed</th>
            <th>Self-Employed</th>
            <th>Studying</th>
            <th>Unemployed</th>
          </tr>
        </thead>
        <tbody>
          {cohorts.map((c) => (
            <tr key={c.batch_id}>
              <td>{c.cohort_number}</td>
              <td>{c.batch_name}</td>
              <td>{c.total_registered}</td>
              <td>{c.profile_completed}</td>
              <td>{c.employed_count}</td>
              <td>{c.self_employed_count}</td>
              <td>{c.studying_count}</td>
              <td>{c.unemployed_count}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default AlumniReports;
